import { Container, CssBaseline } from '@mui/material'
import { BrowserRouter as Router } from 'react-router-dom'
import React from 'react'
import TopLevelRoutes from './Routes'
import Header from '../../components/Header/Header'

const App = (): React.JSX.Element | null => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(180deg, #0b1220 0%, #0f1724 100%)'
      }}
    >
      <CssBaseline />
      <Router>
        <Container maxWidth="xl" disableGutters sx={{ minHeight: '100vh' }}>
          <div className="app-container">
            <Header />
            <TopLevelRoutes />
          </div>
        </Container>
      </Router>
    </div>
  )
}

export default App